import type { SVGProps } from 'react'
const SvgFilter = ({
  color = '#5E5E5E',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.08333 7V5.83333H6.41667V7H4.08333ZM1.75 4.08333V2.91667H8.75V4.08333H1.75ZM0 1.16667V0H10.5V1.16667H0Z"
      fill={color}
    />
  </svg>
)

export default SvgFilter
